import React ,{useState,useMemo,useEffect} from "react";
import { useSelector } from "react-redux";
import { useGetCurrentPlanQuery } from "../slices/getqueries/getqueriesApi";
import PlanCard from "../components/PlanCard";
import PlansPremium from '../assets/PlansPremium.svg'
import bgPlans from "../assets/Pricing.svg";
import { useGetPlansDetailsDataQuery } from "../slices/getqueries/getqueriesApi";
import {format} from 'date-fns';
import Skeleton from '@mui/material/Skeleton';
import { toast } from "react-toastify";
import { formatINRCurrencyWithDecimals } from '../numberFormatter';
import Pagination from '@mui/material/Pagination';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
function NewCurrentPlan() {
    const { userInfo } = useSelector((state) => state.auth);
    const {clientId} = userInfo
    // const { clientId, isAdmin } = userInfo;
    const navigate=useNavigate();
    // const { data: currentplandata, error: errorcurrentplandata } =
    // useGetPlansDetailsDataQuery({ clientname: clientId });
    // console.log(currentplandata);
    const clientname = clientId;
    // const plansData = {
    //   Neo: {
    //     heading: "Everything you need",
    //     actualprice: 1.8,
    //     discount: 40,
    //     finalprice: 1,
    //     purchased:false,
    //     servicesdata: {
    //       KYC: {
    //         "Pan Basic": "₹1.35",
    //         "Pan Detailed": "₹7.35",
    //         "Voter Id": "₹2.10",
    //         "Ration Card": "₹2.10",
    //         "Driving License": "₹3.15",
    //         "CIN": "₹2.10",
    //         "CIN Detailed": "₹7.35",
    //         "DIN": "₹2.10",
    //         "DIN Detailed": "₹7.35",
    //         "GST Basic": "₹1.05",
    //         "GST Detailed": "₹7.35",
    //         "RC Basic": "₹1.05",
    //         "RC Detailed": "₹7.35",
    //         "CIN by DIN": "₹2.10",
    //         "CIN by PAN": "₹2.10",
    //         "KYC OCR": "₹2.10",
    //         "Mobile KYC": "₹3.15",
    //         "UPI ID": "₹2.10",
    //         "Unique Registration Check (non OTP)": "₹2.10",
    //         "Unique Registration Check (with OTP)": "₹3.15",
    //         "Liveness Detection": "₹10.50",
    //         "E-Sign (Standalone)": "₹15.75",
    //         "E-Sign (With KYC Upload)": "₹18.90",
    //         "E-Stamping (100)": "₹93.45",
    //         "E-Stamping (500)": "₹93.45"
    //       },
    //       payments: {
    //         "UPI Verification (Post, Platform Fees)": "₹0.85",
    //         "Netbanking (Post, Platform Fees)": "₹9.75",
    //         "Payouts": "₹3.15",
    //         "Payouts (Wallet)": "₹2.10",
    //         "Mandates Registration (One Time)": "₹10.50",
    //         "Mandate Charge (Below ₹5000)": "₹4.20",
    //         "Mandate Charge (Above ₹5000)": "₹10.50"
    //       },
    //       "credit bureau": {
    //         "Advance, Basic and Verify": "₹6.00"
    //       },
    //       "mobile utilities": {
    //         "Promotional Messages": "₹0.06",
    //         "Transactional Messages": "₹0.13"
    //       },
    //       "banking utilities": {
    //         "Bank Account Verification Advance": "₹1.48",
    //         "Penny Drop ₹1-5000 vols": "₹1.80",
    //         "E-NACH 500-1000 vols": "₹10.50",
    //         "E-NACH 1000-3000 vols": "₹8.40",
    //         "E-NACH 3000-5000 vols": "₹6.30",
    //         "E-NACH 5000-10000 vols": "₹5.25",
    //         "Debit Presentation 1000-3000 vols": "₹2.10",
    //         "Debit Presentation 3000-5000 vols": "₹1.80",
    //         "Debit Presentation 5000+": "₹1.43"
    //       }
    //     }
    //   },
    //   Growth: {
    //     heading: "Everything you need",
    //     actualprice: 3.6,
    //     discount: 45,
    //     finalprice: 2,
    //     purchased:false,
    //     servicesdata: {
    //       KYC: {
    //         "Pan Basic": "₹1.01",
    //         "Pan Detailed": "₹3.15",
    //         "Voter Id": "₹2.10",
    //         "Ration Card": "₹2.10",
    //         "Driving License": "₹2.10",
    //         "CIN": "₹2.10",
    //         "CIN Detailed": "₹3.15",
    //         "DIN": "₹2.10",
    //         "DIN Detailed": "₹3.15",
    //         "GST Basic": "₹1.01",
    //         "GST Detailed": "₹3.15",
    //         "RC Basic": "₹1.01",
    //         "RC Detailed": "₹3.15",
    //         "CIN by DIN": "₹2.10",
    //         "CIN by PAN": "₹2.10",
    //         "KYC OCR": "₹2.10",
    //         "Mobile KYC": "₹2.10",
    //         "UPI ID": "₹1.05",
    //         "Unique Registration Check (non OTP)": "₹2.10",
    //         "Unique Registration Check (with OTP)": "₹2.63",
    //         "Liveness Detection": "₹5.25",
    //         "E-Sign (Standalone)": "₹6.83",
    //         "E-Sign (With KYC Upload)": "₹8.40",
    //         "E-Stamping (100)": "₹93.45",
    //         "E-Stamping (500)": "₹93.45"
    //       },
    //       payments: {
    //         "UPI Verification (Post, Platform Fees)": "₹0.71",
    //         "Netbanking (Post, Platform Fees)": "₹7.75",
    //         "Payouts": "₹2.10",
    //         "Payouts (Wallet)": "₹1.43",
    //         "Mandates Registration (One Time)": "₹6.30",
    //         "Mandate Charge (Below ₹5000)": "₹3.15",
    //         "Mandate Charge (Above ₹5000)": "₹5.25"
    //       },
    //       "credit bureau": {
    //         "Bureau (API & Web/SDK)": "₹1.75"
    //       },
    //       "mobile utilities": {
    //         "Promotional Messages": "₹0.02",
    //         "Transactional Messages": "₹0.08"
    //       },
    //       "banking utilities": {
    //         "Bank Account Verification Advance": "₹0.92",
    //         "Penny Drop ₹1-5000 vols": "₹1.45",
    //         "E-NACH 500-1000 vols": "₹8.40",
    //         "E-NACH 1000-3000 vols": "₹6.30",
    //         "E-NACH 3000-5000 vols": "₹4.20",
    //         "E-NACH 5000-10000 vols": "₹3.15",
    //         "Debit Presentation 1000-3000 vols": "₹1.80",
    //         "Debit Presentation 3000-5000 vols": "₹1.43",
    //         "Debit Presentation 5000+": "₹1.20"
    //       }
    //     }
    //   },
    //   Scale: {
    //     heading: "Everything you need",
    //     actualprice: 8.0,
    //     discount: 50,
    //     finalprice: 4,
    //     purchased:true,
    //     servicesdata: {
    //       KYC: {
    //         "Pan Basic": "₹0.75",
    //         "Pan Detailed": "₹2.10",
    //         "Voter Id": "₹1.05",
    //         "Ration Card": "₹1.05",
    //         "Driving License": "₹1.05",
    //         "CIN": "₹1.05",
    //         "CIN Detailed": "₹2.10",
    //         "DIN": "₹1.05",
    //         "DIN Detailed": "₹2.10",
    //         "GST Basic": "₹0.75",
    //         "GST Detailed": "₹2.10",
    //         "RC Basic": "₹0.75",
    //         "RC Detailed": "₹2.10",
    //         "CIN by DIN": "₹1.05",
    //         "CIN by PAN": "₹1.05",
    //         "KYC OCR": "₹1.05",
    //         "Mobile KYC": "₹1.05",
    //         "UPI ID": "₹0.75",
    //         "Unique Registration Check (non OTP)": "₹1.05",
    //         "Unique Registration Check (with OTP)": "₹1.58",
    //         "Liveness Detection": "₹2.63",
    //         "E-Sign (Standalone)": "₹4.20",
    //         "E-Sign (With KYC Upload)": "₹5.25",
    //         "E-Stamping (100)": "₹93.45",
    //         "E-Stamping (500)": "₹93.45"
    //       },
    //       payments: {
    //         "UPI Verification (Post, Platform Fees)": "₹0.50",
    //         "Netbanking (Post, Platform Fees)": "₹5.25",
    //         "Payouts": "₹1.05",
    //         "Payouts (Wallet)": "₹0.75",
    //         "Mandates Registration (One Time)": "₹5.25",
    //         "Mandate Charge (Below ₹5000)": "₹2.10",
    //         "Mandate Charge (Above ₹5000)": "₹3.15"
    //       },
    //       "credit bureau": {
    //         "Bureau (API & Web/SDK)": "₹1.15"
    //       },
    //       "mobile utilities": {
    //         "Promotional Messages": "₹0.01",
    //         "Transactional Messages": "₹0.04"
    //       },
    //       "banking utilities": {
    //         "Bank Account Verification Advance": "₹0.63",
    //         "Penny Drop ₹1-5000 vols": "₹1.25",
    //         "E-NACH 500-1000 vols": "₹6.30",
    //         "E-NACH 1000-3000 vols": "₹4.20",
    //         "E-NACH 3000-5000 vols": "₹3.15",
    //         "E-NACH 5000-10000 vols": "₹2.10",
    //         "Debit Presentation 1000-3000 vols": "₹1.43",
    //         "Debit Presentation 3000-5000 vols": "₹1.25",
    //         "Debit Presentation 5000+": "₹1.05"
    //       }
    //     }
    //   }
    // };
   
    // const highestPricePlanKey = Object.entries(plansData).reduce(
    //   (maxKey, [key, plan]) =>
    //     plan.actualprice > plansData[maxKey].actualprice ? key : maxKey,
    //   Object.keys(plansData)[0]
    // );
    const handleBack = () => {
      navigate(-1);
    };
    const [servicePage, setServicePage] = useState(1);
    const servicesEntriesPerPage = 15;
    const offset = (servicePage - 1) * servicesEntriesPerPage;


    const queryParams = useMemo(() => {
      const baseParams = {
        clientname,
        limit: servicesEntriesPerPage,
        offset,
      };
      return baseParams;
    }, [clientname, servicesEntriesPerPage, offset]);
    
    const {
      data: serviceData,
      isLoading,
      isFetching,
      isError,
      refetch,
    } = useGetPlansDetailsDataQuery(queryParams);
    // console.log(serviceData);
    const paginatedServices = useMemo(() => {
      if (!serviceData || !Array.isArray(serviceData.services)) return [];
    
      return serviceData.services.map((item) => {
        // const [datePart, timePart] = item["transactiondate&time"].split(" ");
        return {
          name:item.modulename,
          charge:item.chargepercall,
          // id: item.requestId || "-",
          // date: format(new Date(datePart), "dd MMM yyyy"),
          // time: timePart?.slice(0, 8) || "-",
          // creditleft: `₹${item.creditleft.toLocaleString('en-IN')}`,
          // status: (item.status === 200 || item.status === 201) ? "Success" : "Failed",
        };
      });
    }, [serviceData]);

    console.log(paginatedServices)
  const totalServicePages = Math.ceil((serviceData?.totalCount || 0) / servicesEntriesPerPage);

  const handlePageChange = (event, value) => {
  setServicePage(value);
  };
  
useEffect(() => {
  if (!isFetching) {
  if (serviceData) {
      toast.success("Data Fetched successfully!");
    }
  }
}, [isError, isFetching, serviceData]);
  return (
//     <>
//     <p className="font-[600] text-[20px] text-[#212121] mb-3">Plans</p>
//     <div className="relative bg-white p-10 rounded-[10px] overflow-hidden">
  
//   <img
//     src={bgPlans}
//     alt="Background"
//     className="absolute inset-0 w-full h-full object-contain z-0"
//   />


//   <div className="relative z-10 max-w-[90%] mx-auto">
//     <h2 className="text-start text-[24px] font-[600] mt-8">Pick Your Perfect Plan</h2>
//     <p className="text-gray-600 text-start text-[12px] font-[400] mb-16 mt-4">
//       With a range of unique and useful features, managing your world is simple and hassle-free.
//     </p>

//     <div className="grid md:grid-cols-3 gap-20">
//       {Object.entries(plansData).map(([planKey, plan]) => (
//         <div
//           key={planKey}
//           className={`relative rounded-[20px] p-6 border transition-all duration-300 mb-5 ${
//             plan.purchased
//               ? "bg-[#F5F9FF] text-[#212121] z-10 shadow-2xl scale-[1.02] border-[#204887] ring-1 ring-[#204887]"
//               : "bg-white border-gray-200 text-gray-800 shadow-sm z-0"
//           }`}
//         >
//           {planKey === highestPricePlanKey && (
//             <img
//               src={PlansPremium}
//               alt="Premium Badge"
//               className="absolute top-0 right-10 w-[60px] h-[100px] object-contain"
//             />
//           )}

//           <div className="items-start">
//             <h3 className="text-[20px] font-[700]">{planKey}</h3>
//             <p className="text-[10px] font-[400] text-[#212121]">{plan.heading}</p>
//           </div>

//           <div className="flex flex-row gap-4 items-center">
//             <p className="text-[10px] font-[400] mt-8 mb-2 text-[#616161]">
//               <span className="line-through">₹{plan.actualprice}</span> Lakh
//             </p>
//             <span
//               className={`${
//                 plan.purchased
//                   ? "bg-[#183462] text-[#ffffff] font-[600] mt-7 mb-2 px-3 py-1 rounded-full border border-[#E5EFFF] inline-block w-fit"
//                   : "bg-[#E5EFFF] text-[#183462] font-[600] mt-7 mb-2 px-3 py-1 rounded-full border border-[#E5EFFF] inline-block w-fit"
//               }`}
//             >
//               Save {plan.discount}%
//             </span>
//           </div>

//           <p className="text-[30px] font-bold mb-4 text-[#212121]">
//             <span>₹</span> {plan.finalprice} Lakh
//           </p>

//           {Object.entries(plan.servicesdata).map(([section, items]) => (
//             <div key={section} className="mb-0">
//               <h4 className="font-[700] text-[12px] mb-1 capitalize text-[#212121] ml-4">
//                 {section}
//               </h4>
//               <hr className={`${plan.purchased ? "border-[#212121]" : "border-[#212121]"}`} />
//               <ul className="text-sm w-full text-[#212121] mb-4">
//                 {Object.entries(items).map(([label, value]) => (
//                   <li key={label} className="flex justify-between border-none p-[6px]">
//                     <span className="font-[500] text-[11px] break-words">{label}</span>
//                     <span className="font-[600] text-[12px]">{value}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
//       ))}
//     </div>

<div className="">
<div className="flex items-center gap-3 mb-6 cursor-pointer" >
        <FaArrowLeftLong className="w-10 h-10 text-gray-700 hover:text-black transition" onClick={handleBack}/>
        <h2 className="text-[24px] font-semibold text-gray-800">Plans</h2>
      </div>
<div className="bg-white rounded-[15px] shadow p-4 overflow-auto w-full mx-auto">
    {isLoading ? (
      <>
  <table className="w-full min-w-[800px] text-[14px] rounded-[10px]">
    <thead className="bg-[#E5EFFF] text-[#204887]">
      <tr className="text-center font-semibold">
        <th className="customized-table-header">Service</th>
        <th className="customized-table-header">Price</th>

      </tr>
    </thead>
    <tbody>
      {Array.from({ length: 10 }).map((_, index) => (
        <tr key={index}>
          <td className="customized-table-value text-center">
            <Skeleton variant="text" width={100} height={20} animation="wave" />
          </td>
          <td className="customized-table-value text-center">
            <Skeleton variant="text" width={100} height={20} animation="wave" />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</>
    ) : paginatedServices?.length === 0 ? (
      <div className="text-gray-600 flex items-center justify-center text-[15px] py-10">No Data Found</div>
    ) : (
      <>
        <table className="w-full min-w-[800px] text-[14px] rounded-[10px]">
          <thead className="bg-[#E5EFFF] text-[#204887]">
            <tr className="text-center font-semibold">
              <th className="customized-table-header text-center w-1/2">Service</th>
              <th className="customized-table-header text-center w-1/2">Price</th>
            </tr>
          </thead>
          <tbody>
            {paginatedServices.map((tx, index) => (
              <tr key={index} className="text-center">
                <td className="customized-table-value break-words w-1/2">{tx.name}</td>
                <td className="customized-table-value w-1/2">{formatINRCurrencyWithDecimals(tx.charge)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {totalServicePages > 1 && (
          <div className="flex justify-center mt-4">
            <Pagination
              count={totalServicePages}
              page={servicePage}
              onChange={handlePageChange}
              showFirstButton
              showLastButton
              siblingCount={1}
              boundaryCount={1}
              color="primary"
              size="medium"
              sx={{
                '& li': {
                  border: 'none',
                  boxShadow: 'none',
                  margin: 0,
                  padding: 0,
                },
                '& .MuiPaginationItem-root': {
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                },
              }}
            />
          </div>
        )}
      </>
    )}
  </div>
  </div>
  )
}

export default NewCurrentPlan


